import React, { useState } from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import DrillDownTable from '../DrillDownTable';

const tabLabels = [
  'Retractions',
  'High Risk',
  'Medium Risk',
];

interface TabbedDrillDownProps {
  authorId: string
}

const TabbedDrillDown: React.FC<TabbedDrillDownProps> = ({ authorId }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Paper sx={{ margin: 2, padding: 2 }} elevation={2}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label="Drill Down Tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabLabels.map((label, index) => (
          <Tab key={index} label={label} />
        ))}
      </Tabs>

      <Box mt={2}>
        {selectedTab === 0 && <Box sx={{ padding: 2 }}><DrillDownTable
          embed={true}
          journalIds={undefined}
          startYear={1600}
          endYear={2025}
          drillDownTitle="Retractions"
          queryRetractions={true}
          scitilityRiskScoreLowerBoundary={0}
          scitilityRiskScoreHigherBoundary={undefined}
          institutionId={undefined}
          authorId={authorId.toLowerCase()}
        /></Box>}
        {selectedTab === 1 && <Box sx={{ padding: 2 }}><DrillDownTable
          embed={true}
          journalIds={undefined}
          startYear={1600}
          endYear={2025}
          drillDownTitle="High Risk articles"
          queryRetractions={false}
          scitilityRiskScoreLowerBoundary={1.5}
          scitilityRiskScoreHigherBoundary={undefined}
          institutionId={undefined}
          authorId={authorId.toLowerCase()}
        /></Box>}
        {selectedTab === 2 && <Box sx={{ padding: 2 }}><DrillDownTable
          embed={true}
          journalIds={undefined}
          startYear={1600}
          endYear={2025}
          drillDownTitle="Medium Risk articles"
          queryRetractions={false}
          scitilityRiskScoreLowerBoundary={0.5}
          scitilityRiskScoreHigherBoundary={1.5}
          institutionId={undefined}
          authorId={authorId.toLowerCase()}
        /></Box>}
      </Box>
    </Paper>
  );
};

export default TabbedDrillDown;